/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('carway.list', function (el) {
        var itemList = new ItemList(el);
        itemList.run();
    });
    var ItemList = /** @class */ (function () {
        function ItemList(el) {
            var searchInfo = document.querySelector('.search__parameters');
            this.el = el;
            this.currentTab = this.getCurrentTab(document.querySelector('.vehicle__categories .ui-state-active a'));
            this.pickupDate = searchInfo.dataset.pickupDate;
            this.dropoffDate = searchInfo.dataset.dropoffDate;
            this.pickupStation = searchInfo.dataset.pickupStation;
            this.dropoffStation = searchInfo.dataset.dropoffStation;
        }
        ItemList.prototype.run = function () {
            this.bindTabs();
            this.runEvent(this.currentTab);
        };
        ItemList.prototype.bindTabs = function () {
            var _this = this;
            this.el.querySelectorAll('.vehicle__categories li a').forEach(function (tab) {
                util.delegate(tab, 'click', 'a', function (e) {
                    if (e.delegateTarget.id !== _this.currentTab) {
                        _this.currentTab = _this.getCurrentTab(e.delegateTarget);
                        _this.runEvent(_this.currentTab);
                    }
                });
            });
        };
        ItemList.prototype.runEvent = function (currentTab) {
            var selectors = '#' + currentTab + ' .vehicle__entry';
            var vehicles = document.querySelectorAll(selectors);
            var carItems = [];
            vehicles.forEach(function (vehicle) {
                var carInfo = JSON.parse(vehicle.dataset.carInfo);
                carItems.push(carInfo);
            });
            var object = {
                event: "view_item_list",
                ecommerce: {
                    item_list_id: "cars_list",
                    item_list_name: "List of available cars",
                    pickup_station_code: this.pickupStation,
                    dropoff_station_code: this.dropoffStation,
                    pickup_date: this.pickupDate,
                    dropoff_date: this.dropoffDate,
                    items: carItems,
                },
            };
            this.pushToLayer(object);
        };
        ItemList.prototype.getCurrentTab = function (htmlAnchorElement) {
            if (htmlAnchorElement === null) {
                htmlAnchorElement = document.querySelector('.vehicle__categories .category--selected a');
            }
            return htmlAnchorElement.href.substr(htmlAnchorElement.href.indexOf('#') + 1);
        };
        ItemList.prototype.pushToLayer = function (object) {
            // @ts-ignore
            window.dataLayer = window.dataLayer || [];
            // @ts-ignore
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            // @ts-ignore
            window.dataLayer.push(object);
        };
        return ItemList;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
